import { Component } from '@angular/core';
import { LocalStorageHelperService } from 'src/app/shared/services/local-storage-helper.service';
import { StorageUtilsService } from '../../services/storage-utils.service';

@Component({
  selector: 'storage-home',
  templateUrl: './storage-home.component.html',
  styleUrl: './storage-home.component.scss',
  standalone: false,
})
export class StorageHomeComponent {
  isListView = false;
  StorageUtilsService = StorageUtilsService;

  constructor(private localStorageHelperService: LocalStorageHelperService) {
    const savedIsListView =
      this.localStorageHelperService.get('storage.isListView');
    if (savedIsListView) {
      this.isListView = true;
    }
  }

  isListViewChange(isListView: boolean) {
    this.isListView = isListView;
    try {
      this.localStorageHelperService.set('storage.isListView', isListView);
    } catch (error) {
      // If localStorage fails, default to saving false
      try {
        this.localStorageHelperService.set('storage.isListView', false);
      } catch (secondError) {
        // If localStorage completely fails, just continue without saving
      }
    }
  }
}
